document.addEventListener( 'DOMContentLoaded', function()
{
    const questions = document.querySelectorAll( '.bridgman_faq__question' );
    questions.forEach(( question, index ) =>
    {
        const answer = question.nextElementSibling;
        const expandButton = question.querySelector( '.expand-button' );
        const plusIcon = expandButton.querySelector( '.plus-icon' );
        question.addEventListener( 'click', () =>
        {
            questions.forEach((otherQuestion, otherIndex) =>
            {
                if ( otherIndex !== index )
                {
                    const otherAnswer = otherQuestion.nextElementSibling;
                    const otherExpandButton = otherQuestion.querySelector( '.expand-button' );
                    const otherPlusIcon = otherExpandButton.querySelector( '.plus-icon' );
                    otherAnswer.style.maxHeight = null;
                    otherPlusIcon.classList.remove( 'rotate' );
                    otherAnswer.classList.remove( 'active' )
                }
            });
            if ( answer.style.maxHeight )
            {
                answer.classList.remove( 'active' )
                answer.style.maxHeight = null;
                plusIcon.classList.remove( 'rotate' );
            }
            else
            {
                answer.style.maxHeight = answer.scrollHeight + 6 + 'px';
                answer.classList.add( 'active' )
                plusIcon.classList.add( 'rotate' );
            }
        });
        // By default, collapse all answers except the first one
        if (index !== 0)
        {
            answer.style.maxHeight = null;
            plusIcon.classList.remove( 'rotate' );
            answer.classList.remove( 'active' )
        }
    });

    // form submit event listener
    var form = document.querySelector( ".home-visit-form" );
    if( form )
    {
        form.addEventListener( "submit", function (e) {
            e.preventDefault();
    
            var formControls = form.querySelectorAll( '.lighting-form-control' );
            var homeVisitData       = {};
            var customerProperties  = {};
            var email;
    
            formControls.forEach(function ( formControl ) 
            {
                var formControlName = formControl.getAttribute( "name" );
                var input = form.querySelector( 'input[name="' + formControlName + '"]' );
                var select = form.querySelector( 'select[name="' + formControlName + '"]' );
                var textarea = form.querySelector('textarea[name="' + formControlName + '"]');
                var checkbox = form.querySelector('input[type="checkbox"][name="' + formControlName + '"]');
    
                var formInputValue;
                if ( input ) 
                {
                    homeVisitData[ formControlName ] = input.value;
                    if ( input.type === "email" ) 
                    {
                        email                           = input.value;
                        customerProperties[ "$email" ]  = email;
                        homeVisitData[ "$email" ]  = email;
                    }
                    formInputValue = input.value;
                 
                    if ( checkbox ) 
                    {
                        if (checkbox.checked) 
                        {
                            homeVisitData[ formControlName ] = true;
                            formInputValue                   = true;
                        }
                        else
                        {
                            homeVisitData[ formControlName ] = false;
                            formInputValue                   = false;
                        }
                    }
                } 
                else if ( select ) 
                {
                    homeVisitData[ formControlName ] = select.options[ select.selectedIndex ].value;
                    formInputValue                   = select.options[ select.selectedIndex ].value;
                } 
                else if ( textarea ) 
                {
                    homeVisitData[ formControlName ] = textarea.value;
                    formInputValue                   = textarea.value
                }
    
                var klaviyoCustomProperty = formControl.getAttribute( "data-klaviyo-custom-property" );
                if( klaviyoCustomProperty )
                {
                    customerProperties[ klaviyoCustomProperty ] = formInputValue;
                    homeVisitData[ klaviyoCustomProperty ] = formInputValue;
                }
            });
    
            var zapierHook  = document.querySelector( "[data-zapier-hook]" ).dataset.zapierHook;
            var requestType = document.querySelector( "[data-request-type]" ).dataset.requestType;
            
            var properties  =  { "$email" : email };
            var trackProperties  = { "event" : requestType, "trackData" : homeVisitData };
            KlaviyoTrackV2( properties, trackProperties, function()
            {
                jQuery.post( zapierHook, homeVisitData ).then( function(response)
                {
                    //console.log('Success', response);
                    var successMessage = document.querySelector('.success_message');
                    successMessage.style.display = 'block';
                    setTimeout(() => {
                        successMessage.style.display = "none";
                    }, 3000);
                    form.reset();
                } );
            });
        });
    }
});